import _toConsumableArray from "/builder/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builder/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { extension, command, keyBinding, NamedShortcut, MarkExtension, ExtensionTag, toggleMark, markInputRule } from '@remirror/core';
import { ExtensionItalicMessages } from '@remirror/messages';
var toggleItalicOptions = {
  icon: 'italic',
  label: function label(_ref) {
    var t = _ref.t;
    return t(ExtensionItalicMessages.LABEL);
  },
  description: function description(_ref2) {
    var t = _ref2.t;
    return t(ExtensionItalicMessages.DESCRIPTION);
  }
};

var _dec, _dec2, _dec3, _class, _class2;
/**
 * Add italic formatting to your editor.
 */


var ItalicExtension = (_dec = extension({}), _dec2 = command(toggleItalicOptions), _dec3 = keyBinding({
  shortcut: NamedShortcut.Italic,
  command: 'toggleItalic'
}), _dec(_class = (_class2 = /*#__PURE__*/function (_MarkExtension) {
  _inherits(ItalicExtension, _MarkExtension);

  var _super = _createSuper(ItalicExtension);

  function ItalicExtension() {
    _classCallCheck(this, ItalicExtension);

    return _super.apply(this, arguments);
  }

  _createClass(ItalicExtension, [{
    key: "name",
    get: function get() {
      return 'italic';
    }
  }, {
    key: "createTags",
    value: function createTags() {
      return [ExtensionTag.FontStyle, ExtensionTag.FormattingMark];
    }
  }, {
    key: "createMarkSpec",
    value: function createMarkSpec(extra, override) {
      var _override$parseDOM;

      return _objectSpread(_objectSpread({}, override), {}, {
        attrs: extra.defaults(),
        parseDOM: [{
          tag: 'i',
          getAttrs: extra.parse
        }, {
          tag: 'em',
          getAttrs: extra.parse
        }, {
          style: 'font-style=italic'
        }].concat(_toConsumableArray((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])),
        toDOM: function toDOM(mark) {
          return ['em', extra.dom(mark), 0];
        }
      });
    }
  }, {
    key: "createKeymap",
    value: function createKeymap() {
      return {
        'Mod-i': toggleMark({
          type: this.type
        })
      };
    }
  }, {
    key: "createInputRules",
    value: function createInputRules() {
      return [markInputRule({
        regexp: /(?:^|[^*])\*([^*]+)\*$/,
        type: this.type,
        ignoreWhitespace: true,
        updateCaptured: function updateCaptured(_ref) {
          var fullMatch = _ref.fullMatch,
              start = _ref.start;
          return !fullMatch.startsWith('*') ? {
            fullMatch: fullMatch.slice(1),
            start: start + 1
          } : {};
        }
      }), markInputRule({
        regexp: /(?:^|[^_])_([^_]+)_$/,
        type: this.type,
        ignoreWhitespace: true,
        updateCaptured: function updateCaptured(_ref2) {
          var fullMatch = _ref2.fullMatch,
              start = _ref2.start;
          return !fullMatch.startsWith('_') ? {
            fullMatch: fullMatch.slice(1),
            start: start + 1
          } : {};
        }
      })];
    }
  }, {
    key: "createPasteRules",
    value: function createPasteRules() {
      return [{
        type: 'mark',
        markType: this.type,
        regexp: /_([^_]+)_/g
      }, {
        type: 'mark',
        markType: this.type,
        regexp: /\*([^*]+)\*/g
      }];
    }
    /**
     * Toggle the italic formatting on the selected text.
     */

  }, {
    key: "toggleItalic",
    value: function toggleItalic(selection) {
      return toggleMark({
        type: this.type,
        selection: selection
      });
    }
    /**
     * Attach the keyboard shortcut for formatting.
     */

  }, {
    key: "shortcut",
    value: function shortcut(props) {
      return this.toggleItalic()(props);
    }
  }]);

  return ItalicExtension;
}(MarkExtension), (_applyDecoratedDescriptor(_class2.prototype, "toggleItalic", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleItalic"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "shortcut", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "shortcut"), _class2.prototype)), _class2)) || _class);
export { ItalicExtension };